import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomPopup from "../../custom-components/CustomPopup";

const PrivacyPolicyPopup: FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    return (
        <CustomPopup
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            closingCrossClassName="mb-[15px] dmax2:mb-3 dmax2:w-[30px]"
            buttonElement={
                <div onClick={() => setIsVisible(true)} className="H16 text-[#848484] mb-[6px] cursor-pointer">
                    {t("footer.privacyPolicy")}
                </div>
            }
        >
            <div className="relative w-[740px] md4:w-[360px] mi5:w-[320px]">
                <div className="relative flex flex-col items-center w-full h-full bg-white rounded-sm px-[50px] dmax5:px-[15px] py-10 dmax5:py-5">
                    <h2 className="H20 mb-7 dmax2:mb-6">{t("privacyPolicy.title")}</h2>
                    <div className="flex flex-col">
                        <p className="H14 dmax2:H12 mb-4">{t("privacyPolicy.text1")}</p>
                        <p className="H16B dmax2:H14B mb-2">{t("privacyPolicy.subTitle1")}</p>
                        <p className="H14 dmax2:H12 mb-4">{t("privacyPolicy.text2")}</p>
                        <p className="H16B dmax2:H14B mb-2">{t("privacyPolicy.subTitle2")}</p>
                        <p className="H14 dmax2:H12 mb-4">{t("privacyPolicy.text3")}</p>
                        <p className="H16B dmax2:H14B mb-2">{t("privacyPolicy.subTitle3")}</p>
                        <p className="H14 dmax2:H12 mb-4">{t("privacyPolicy.text4")}</p>
                        <p className="H16B dmax2:H14B mb-2">{t("privacyPolicy.subTitle4")}</p>
                        <p className="H14 dmax2:H12 mb-4">{t("privacyPolicy.text5")}</p>
                        <p className="H14 dmax2:H12 mb-7">{t("privacyPolicy.text6")}</p>
                    </div>
                    <div
                        onClick={() => setIsVisible(false)}
                        className="flex justify-center items-center H16 dmax2:H14 border border-black text-[#FCFAF0] bg-black hover:text-black hover:bg-white transition-all duration-300 rounded-[3px] w-[230px] h-[45px] cursor-pointer"
                    >
                        {t("privacyPolicy.okay")}
                    </div>
                </div>
            </div>
        </CustomPopup>
    );
};

export default PrivacyPolicyPopup;
